import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "../InputField";
import SubmitButton from "../SubmitButton";
import { useAuthActions } from "../../features/auth/useAuthActions"; // ایمپورت هوک

export default function LoginWithPasswordForm() {
  const { loginPassword } = useAuthActions(); // استفاده از اکشن لاگین
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      // استفاده از متد تعریف شده در لایه سرویس/هوک
      await loginPassword(formData.phone, formData.password);

      // هدایت و رفرش برای پاکسازی سبد خرید
      navigate("/");
      window.location.reload();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setErrorMsg("شماره موبایل یا رمز عبور اشتباه است.");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <InputField
        label="شماره موبایل"
        name="phone"
        value={formData.phone}
        onChange={(e) => setFormData({...formData, phone: e.target.value})}
      />
      <InputField
        label="رمز عبور"
        type="password"
        name="password"
        value={formData.password}
        onChange={(e) => setFormData({...formData, password: e.target.value})}
      />
      {errorMsg && <p className="text-red-600 text-sm">{errorMsg}</p>}
      <SubmitButton text={loading ? "در حال ورود..." : "ورود"} />
    </form>
  );
}
